import React from "react";
import "../styles.css";

/**
 * GlowLayer
 * ----------
 * Soft romantic glow overlay
 * - Adds warmth & magic
 * - Stays behind image
 * - Mobile optimized
 */
export default function GlowLayer() {
  return <div className="glow-layer" />;
}
